<template>
  <table class="product-rows product-rows--order-history">
    <thead>
      <tr>
        <th class="product-row__head-order-number">
          <div v-epi-edit="'HeaderOrderNumber'" class="product-row__head-inset">
            <span>
              {{ t('headerOrderNumber') }}
            </span>
          </div>
        </th>

        <th class="product-row__head-order-date">
          <div v-epi-edit="'HeaderOrderDate'" class="product-row__head-inset">
            {{ t('headerOrderDate') }}
          </div>
        </th>

        <th class="product-row__head-stock-status">
          <div v-epi-edit="'HeaderOrderStatus'" class="product-row__head-inset">
            {{ t('headerOrderStatus') }}
          </div>
        </th>

        <th class="product-row__head-order-comment">
          <div v-epi-edit="'HeaderOrderComment'" class="product-row__head-inset">
            {{ t('headerOrderComment') }}
          </div>
        </th>

        <th class="product-row__head-total-sum">
          <div v-epi-edit="'HeaderOrderPrice'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>{{ t('headerOrderPrice') }}<!--Totalt (exkl. moms)--></span>
          </div>
        </th>

        <th v-if="orderReturnSettings.enabled" class="product-row__head-order-alternatives">
          <div v-epi-edit="'HeaderOrderAlternatives'" class="product-row__head-inset product-row__head-inset--align-right">
            <span>
              {{ t('headerOrderReturn') }}
            </span>
          </div>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(order, row) in orders" :key="`table-row-${row}`">
        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerOrderNumber') }}
          </div>

          <div class="product-row__body-inset">
            <a :href="`${clientModel.orderHistoryDetailUrl}?orderNumber=${order.orderNr}`" class="product-row__order-number">
              {{ order.orderNr }}
            </a>
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerOrderDate') }}
          </div>

          <div class="product-row__body-inset">
            {{ order.displayOrderDate }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerOrderStatus') }}
          </div>

          <div class="product-row__body-inset">
            <oie-product-status :status="statusType(order.orderStatus)" :text="statusText(order)" size="medium"></oie-product-status>
          </div>
        </td>

        <td class="product-row__td--comment">
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerOrderComment') }}
          </div>

          <div class="product-row__body-inset">
            {{ order.comment }}
          </div>
        </td>

        <td>
          <div v-if="mq('to-medium')" class="product-row__body-header">
            {{ t('headerOrderPrice') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right product-row__body-inset--price">
            {{ formatPrice(order.orderSum) }}
          </div>
        </td>

        <td v-if="orderReturnSettings.enabled">
          <div v-if="mq('to-medium')" class="product-row__body-header product-row__body-inset--align-right">
            {{ t('headerOrderReturn') }}
          </div>

          <div class="product-row__body-inset product-row__body-inset--align-right">
            <a :href="getOrderReturnUrl(order.orderNr)" class="product-row__order-return">
              <oie-use-svg svg="order-return"></oie-use-svg><span v-if="mq('small')"><span v-html="getIssueNumbers(order.orderNr)"></span></span>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    orderReturnSettings: {
      enabled: false
    },
    customer: {
      orderReturnIssues: []
    }
  }),
  mounted() {
    httpService
      .get(`order-return/settings`, {})
      .then(response => {
        this.orderReturnSettings = response.data
      })

    httpService
      .get(`order-return/customer`, {})
      .then(response => {
        this.customer = response.data
      })
  },
  methods: {
    getIssueNumbers(orderNumber) {
      let orderReturnIssues = this.customer.orderReturnIssues.filter(c => c.orderNumber === orderNumber)

      if (orderReturnIssues === null || orderReturnIssues.length === 0) {
        return this.t('orderReturnTitle')
      }

      let keys = ''

      for (const issue of orderReturnIssues) {
        if (keys.length > 0) {
          keys += ', '
        }

        keys += issue.key
      }

      return this.t('orderReturnIssueTitle') + ' <span class="issue-number">' + keys + '</span>'
    },
    statusText(order) {
      if (order.orderStatusKey === 'open') {
        return this.t('statusOpen')
      } else if (order.orderStatusKey === 'openPartiallyDelivered') {
        return this.t('statusOpenPartiallyDelivered')
      } else if (order.orderStatusKey === 'released') {
        return this.t('statusReleased')
      }

      return ''

      /*
      if (statusCode === '10' || statusCode === '11' || statusCode === '13') {
        return this.t('statusTypeReceived')
      }

      if (statusCode === '20') {
        // return this.t('statusTypePartDelivered')
        return 'Dellevererad med restnotering'
      }

      if (statusCode === '40') {
        return this.t('statusTypePacked')
      }

      if (statusCode === '50' || statusCode === '70') {
        // return this.t('statusTypeShipped')
        return 'Skickad'
      }
      */
    },
    statusType(statusCode) {
      if (statusCode === '10' || statusCode === '11' || statusCode === '13' || statusCode === '20') {
        return 'few-stock'
      }

      if (statusCode === '40' || statusCode === '50' || statusCode === '70') {
        return 'in-stock'
      }
    },
    getOrderReturnUrl(orderNumber) {
      if (!this.orderReturnSettings.useCustomerOrderReturnPage) {
        return `${this.clientModel.orderReturnUrl}?orderNumber=${orderNumber}`
      } else {
        return `${this.clientModel.customerOrderReturnUrl}?orderNumber=${orderNumber}`
      }
    }
  }
}
</script>

<style lang="scss">
  .product-rows--order-history .product-row__body-inset {
    min-height: initial;
  }

  .product-row__order-return {
    text-decoration: none;
  }

  .product-row__order-return:hover {
    text-decoration: underline;
  }

  .product-row__order-return > span {
    font-family: Open Sans,sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #0088c8;
    padding-left: 4px;
    padding-bottom: 4px;
  }

  .issue-number {
    color: #e48123;
  }
</style>
